import React from 'react';

import Grid from '@material-ui/core/Grid';
import FacebookIcon from '@material-ui/icons/Facebook';
import TwitterIcon from '@material-ui/icons/Twitter';
import YouTubeIcon from '@material-ui/icons/YouTube';
import InstagramIcon from '@material-ui/icons/Instagram';
import PinterestIcon from '@material-ui/icons/Pinterest';
import LinkedInIcon from '@material-ui/icons/LinkedIn';

export default (props) => {
  return (
    <Grid container direction="row" justify="flex-start" spacing={1}>
      <Grid item><a href="https://www.facebook.com/corrivium" target="_blank" rel="noopener noreferrer"><FacebookIcon /></a></Grid>
      <Grid item><a href="https://twitter.com/corrivium" target="_blank" rel="noopener noreferrer"><TwitterIcon /></a></Grid>
      <Grid item><a href="http://www.youtube.com/user/corrivium" target="_blank" rel="noopener noreferrer"><YouTubeIcon /></a></Grid>
      <Grid item><a href="http://instagram.com/corrivium" target="_blank" rel="noopener noreferrer"><InstagramIcon /></a></Grid>
      <Grid item><a href="http://www.pinterest.com/corrivium" target="_blank" rel="noopener noreferrer"><PinterestIcon /></a></Grid>
      <Grid item><a href="http://www.linkedin.com/company/corrivium" target="_blank" rel="noopener noreferrer"><LinkedInIcon /></a></Grid>
    </Grid>
  );
}
